import type { ElementType, ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import type { TableFooterProps } from "./Table.types";

const TableFooterComponent = (props: TableFooterProps): ReactElement => {
  const { as, className, style, children } = props;
  const Component = (as || "tfoot") as ElementType;
  return (
    <Component className={className} style={style}>
      {children}
    </Component>
  );
};

export const TableFooter = styled(TableFooterComponent)``;
